export enum OverrideRiskFieldTypes {
    None = 1,
    Default = 2,
    Mandatory = 3,
}
